/* global hljs */
import load, { loadStyle } from '@lemuria/load-scripts'

export default class HighlightJs {
  constructor(el) {
    this.el = el
  }
  /**
   * @suppress {checkTypes}
   */
  static 'load'(cb, el, { theme = 'default', lang, dev, splendid: { mount } }) {
    if (!lang) cb(new Error('The language was not specified.'))
    const langs = lang.split(',').map(getLanguage)
    load([
      `${mount}js/highlight.pack.js`,
      // '/node_modules/highlight.js/lib/highlight.js',
    ], (err) => {
      if (err) return cb(err)
      load(langs, cb)
    })
    if (theme) loadStyle(`${mount}highlight.js/styles/${theme}.css`, (err, ev) => {
    })
  }
  /**
   * @suppress {checkTypes}
   */
  static get 'plain'() {
    return true
  }
  render() {
    const code = this.el.querySelector('code')
    hljs.highlightBlock(code)
  }
}

const getLanguage = (lang) => {
  return `https://cdnjs.cloudflare.com/ajax/libs/highlight.js/9.18.1/languages/${lang}.min.js`
}